module.exports = __webpack_public_path__ + "img/Tang.bea87767.png";